import { useEffect, useState } from "react";
import { LoginAs } from "../LoginAs";
import { useDispatch, useSelector } from "react-redux";
import { updateFilter } from "../../../store/slices/ProductFinder/ProductFinderSlice";
import { formatFilterObj } from "../../../helpers/helperFunctions";

export default function PromoCarousel() {
  const { promoImages } = useSelector((state) => state.admin);

  const [currentIndex, setCurrentIndex] = useState(0);

  const dispatch = useDispatch();

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % promoImages.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev === 0 ? promoImages.length - 1 : prev - 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % promoImages.length);
    }, 5000); // 5000ms = 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [promoImages.length]);

  return (
    <div className="relative w-full " id="promo-carousel">
      <div className="relative h-56 overflow-hidden rounded-lg md:h-96">
        {/* Desktop-only absolute position */}
        <div className="absolute top-2 right-2 z-20 hidden sm:block">
          <LoginAs className="bg-white/70 text-sm p-2 pr-3 rounded-md shadow-sm border border-gray-300" />
        </div>

        {promoImages.map((img, idx) => (
          <div
            key={img.id}
            className={`absolute inset-0 transition-opacity duration-700 ease-in-out hover:cursor-pointer ${
              idx === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
            onClick={() => {
              dispatch(updateFilter(formatFilterObj(img.search_string)));
            }}
          >
            {/* Image */}
            <img
              src={img.image_url}
              className="block w-full h-full object-contain "
              alt={`Promo ${idx}`}
            />

            {/* Label BELOW the image */}
            {img.label && (
              <div className="absolute bottom-0 left-0 w-full text-center bg-black/40 text-white !text-lg md:text-base font-medium py-1">
                {img.label}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Prev Button */}
      <button
        onClick={prevImage}
        type="button"
        className="absolute bottom-12 left-4 z-30 flex items-center justify-center cursor-pointer group focus:outline-none"
      >
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[var(--primary-color)] hover:bg-[var(--primary-color-light)] group-focus:ring-2 group-focus:ring-white">
          <svg
            className="w-4 h-4 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 6 10"
          >
            <path d="M5 1 1 5l4 4" />
          </svg>
          <span className="sr-only">Previous</span>
        </span>
      </button>

      {/* Next Button */}
      <button
        onClick={nextImage}
        type="button"
        className="absolute bottom-12 right-4 z-30 flex items-center justify-center cursor-pointer group focus:outline-none"
      >
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-[var(--primary-color)] hover:bg-[var(--primary-color-light)] group-focus:ring-2 group-focus:ring-white">
          <svg
            className="w-4 h-4 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            viewBox="0 0 6 10"
          >
            <path d="m1 9 4-4-4-4" />
          </svg>
          <span className="sr-only">Next</span>
        </span>
      </button>
    </div>
  );
}
